import { render, staticRenderFns } from "./BrandMapping.vue?vue&type=template&id=20ac07b7&scoped=true"
import script from "./BrandMapping.vue?vue&type=script&lang=js"
export * from "./BrandMapping.vue?vue&type=script&lang=js"
import style0 from "./BrandMapping.vue?vue&type=style&index=0&id=20ac07b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac07b7",
  null
  
)

export default component.exports